// create multiple animations and export them

export const titleInitial = {
  opacity: 0,
  y: 25,
};

export const titleAnimate = (delay = 0.25, duration = 1) => ({
  opacity: 1,
  y: 0,
  transition: { duration: duration, delay: delay, ease: "easeOut" },
});

export const featureInitial = {
  opacity: 0,
  y: 150,
};

export const featureAnimate = (i) => ({
  opacity: 1,
  y: 0,
  transition: {
    duration: 2,
    delay: 0.25 + i * 0.15,
    ease: "easeOut",
  },
});
